const topPropertyTypeCodes = [22, 16, 5, 6, 12, 1, 17, 14];

const bottomPropertyTypeCodes = [40, 8, 9, 43, 24, 36, 10, 7,
    23, 11, 29, 41, 42, 26, 18, 4, 15, 2, 30, 32,
    31, 3, 13, 33, 25, 20, 37, 34, 21];

export {
    topPropertyTypeCodes,
    bottomPropertyTypeCodes
};
